import { ArrowLeft } from "lucide-react";

export function JourneyHeader({ title, subtitle, onBack }: { title: string; subtitle?: string; onBack: () => void }) {
  return <div className="flex items-center gap-3">
    <button onClick={onBack} className="glass-icon grid h-11 w-11 place-items-center rounded-full" aria-label="Voltar"><ArrowLeft className="h-5 w-5"/></button>
    <div className="min-w-0"><p className="text-[10px] font-bold uppercase tracking-[.16em] text-teal-light">YamarHub</p><h1 className="font-display text-2xl font-semibold text-white">{title}</h1>{subtitle&&<p className="mt-0.5 text-xs text-white/45">{subtitle}</p>}</div>
  </div>;
}
